import { Choice } from '@dreryk/watermelon';

import { isMagistralDrugPrescription } from '../guards/isMagistralDrugPrescription';
import { isStandardPrescription } from '../guards/isStandardPrescription';
import { DraftPrescription, Prescription } from '../types';

export const mapSentPrescriptionPackagesToDraftPrescription = (prescription: Prescription): DraftPrescription => {
   return {
      id: prescription.id,
      additionalEntitlementTypes: prescription.additionalEntitlementTypes.map((type) => type),
      dosage: Choice.withUseDefaultIfNull(prescription.dosage ?? null),
      issuedFrom: prescription.issuedFrom,
      issuedTo: prescription.issuedTo,
      medicineId: isStandardPrescription(prescription)
         ? prescription.medicinePrescription.patientMedicine.medicine.id
         : undefined,
      magistralDrugId: isMagistralDrugPrescription(prescription)
         ? prescription.medicinePrescription.magistralDrug.id
         : undefined,
      quantity: prescription.quantity,
      reimbursementType: Choice.withUseDefaultIfNull(prescription.reimbursementType ?? null),
      substituteForbidden: prescription.substituteForbidden,
      cito: false, // TODO: DREGAB-3969 Waiting for implementation - cito flag,
      preciseDosage: Choice.withUseDefaultIfNull(prescription.preciseDosage ?? null),
      extendedDosage: Choice.withUseDefaultIfNull(prescription.extendedDosage ?? null),
      treatmentDays: Choice.withUseDefaultIfNull(prescription.treatmentDays ?? null),
      displayIndex: prescription.displayIndex,
   };
};
